import * as React from "react";
import * as ReactDOM from "react-dom";
import Ajax from "../../Ajax";
import EditService from "./EditService";
import NewService from "./NewService";
import ServicesDatatable from "./ServicesDatatable";

interface IFormProps {
}
interface MyStates {
  ajaxLoaded: boolean,
  add_new: boolean,
  edit_id: number,
  close: boolean
}
export default class ReservatioServices extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      ajaxLoaded: true,
      add_new: false,
      edit_id: 0,
      close: false
    }
  }

  private setForEdit( id ) {
    this.setState({
      add_new: false,
      close: false,
      edit_id: id
    })
  }

  private addNew( ) {
    this.setState({
      add_new: true,
      close: false,
      edit_id: 0
    })
  }

  private setClose( e ) {
    this.setState({
      close: true
    })
  }

  public render() {
    if(this.state.ajaxLoaded === true){
      return (
      <>
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <button className="btn btn-success btn-sm" onClick={() => this.addNew()}><i className="fa fa-plus"></i> Új szolgáltatás hozzáadása</button>
          </div>
        </div>
      </div>
        <div className="row">
          <div className="col-md-7">
            <ServicesDatatable setForEdit={(e) => this.setForEdit(e)} />
          </div>
          <div className="col-md-5" key={'editfield_' + Math.random()}>
            {
              this.state.close 
              ?
                ''
              :
              (
                this.state.add_new
                ?
                  <NewService setClose={(e) => this.setClose(e)}  setForEdit={(e) => this.setForEdit(e)} />
                :
                  <EditService setClose={(e) => this.setClose(e)}  id={this.state.edit_id} setForEdit={(e) => this.setForEdit(e)} />
              )
            }
          </div>
        </div>
      </>
      );
    }else{
      return (<>Betöltés..</>)
    }
  }
}

export class InitReservatioServices {
  constructor() {
      var div: HTMLDivElement = document.getElementById('reservatio_services_app') as HTMLDivElement;
      if (div !== null) {
          var data:any = div.dataset;
          ReactDOM.render(<ReservatioServices />, div);
      }
  }
}